// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/landingPageMatrixBG.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/landingpagePerfectForImg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.2 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
*/

html {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
}
.relative {
  position: relative;
}
.right-20 {
  right: 5rem;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}
.my-2 {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.my-3 {
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}
.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-24 {
  margin-top: 6rem;
}
.flex {
  display: flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-12 {
  height: 3rem;
}
.h-2 {
  height: 0.5rem;
}
.h-36 {
  height: 9rem;
}
.h-6 {
  height: 1.5rem;
}
.h-8 {
  height: 2rem;
}
.h-\\[30px\\] {
  height: 30px;
}
.h-full {
  height: 100%;
}
.min-h-\\[50vh\\] {
  min-height: 50vh;
}
.w-14 {
  width: 3.5rem;
}
.w-2 {
  width: 0.5rem;
}
.w-28 {
  width: 7rem;
}
.w-8 {
  width: 2rem;
}
.w-\\[100\\%\\] {
  width: 100%;
}
.w-\\[65\\%\\] {
  width: 65%;
}
.w-full {
  width: 100%;
}
.w-max {
  width: max-content;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-\\[87\\%\\] {
  max-width: 87%;
}
.max-w-max {
  max-width: max-content;
}
.flex-grow {
  flex-grow: 1;
}
.cursor-pointer {
  cursor: pointer;
}
.select-none {
  -webkit-user-select: none;
          user-select: none;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.place-content-center {
  place-content: center;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.scroll-smooth {
  scroll-behavior: smooth;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.rounded-full {
  border-radius: 9999px;
}
.border {
  border-width: 1px;
}
.border-b-\\[1px\\] {
  border-bottom-width: 1px;
}
.border-t-\\[1px\\] {
  border-top-width: 1px;
}
.bg-slate-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(203 213 225 / var(--tw-bg-opacity));
}
.bg-slate-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(148 163 184 / var(--tw-bg-opacity));
}
.bg-slate-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(71 85 105 / var(--tw-bg-opacity));
}
.bg-slate-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity));
}
.bg-transparent {
  background-color: transparent;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.pb-4 {
  padding-bottom: 1rem;
}
.text-center {
  text-align: center;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-\\[13px\\] {
  font-size: 13px;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.text-slate-400 {
  --tw-text-opacity: 1;
  color: rgb(148 163 184 / var(--tw-text-opacity));
}
.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity));
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

html {
  font-family: "Open Sans";
  scroll-behavior: smooth;
  /* user-select: none !important; */
  -webkit-tap-highlight-color: rgba(
    0,
    0,
    0,
    0
  ); /* handling-the blue effect on mobile device--  */
}

/* scroll removed from input type=number */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
::-webkit-scrollbar-track {
  background-color: #141414;
}
::-webkit-scrollbar-thumb {
  background-color: rgb(91, 99, 109);
  border-radius: 20px;
}

.App {
  display: flex;
  min-height: 100vh;
  overflow: hidden;
  --tw-bg-opacity: 1;
  background-color: rgb(17 17 17 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
/* /* dashboard */
.dashboard-wrapper,
.history-wrapper {
  position: relative;
  min-height: 100%;
  width: 100%;
  overflow: auto;
  padding: 1rem;
  padding-bottom: 0px;
}

.chat-box {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0.75rem;
  max-height: calc(100vh - 170px);
  width: 90%;
  overflow: auto;
  line-height: 1.5rem;
  letter-spacing: 0.025em;
}

@media (min-width: 640px) {

  .chat-box {
    max-height: calc(100vh - 130px);
  }
}

@media (min-width: 768px) {

  .chat-box {
    width: 85%;
  }
}

.chat-form {
  position: absolute;
  left: 50%;
  bottom: 0px;
  margin-bottom: 1.25rem;
  width: 90%;
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@media (min-width: 640px) {

  .chat-form {
    margin-bottom: 1.5rem;
  }
}

@media (min-width: 768px) {

  .chat-form {
    width: 82%;
  }
}
.chat-input {
  margin: auto;
  width: 100%;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(69 69 69 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(37 37 39 / var(--tw-bg-opacity));
  padding-left: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-right: 3.4rem;
  outline: 2px solid transparent;
  outline-offset: 2px;
}
@media (min-width: 1024px) {

  .chat-input {
    padding-left: 1rem;
    padding-right: 3.4rem;
  }
}
.mic {
  position: absolute;
  right: 2.25rem;
  top: 16%;
  margin-right: 1.25rem;
}
.inp-btn,
.loader {
  position: absolute;
  right: 1rem;
  top: 50%;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.chat {
  margin-top: 1rem;
  margin-bottom: 1.5rem;
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 0.5rem;
  overflow: auto;
  white-space: pre-wrap;
}
.user-chat {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(21 21 23 / var(--tw-bg-opacity));
  padding: 0.5rem;
}
@media (min-width: 640px) {

  .user-chat {
    gap: 1rem;
    padding: 1rem;
  }
}
.bot-top-chat {
  display: flex;
  align-items: flex-start;
  gap: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(21 21 23 / var(--tw-bg-opacity));
}
@media (min-width: 640px) {

  .bot-top-chat {
    gap: 1rem;
  }
}

.chat-history {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 0.5rem;
  overflow: auto;
  white-space: pre-wrap;
}
.bot-chathistory-wrapper {
  position: relative;
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(21 21 23 / var(--tw-bg-opacity));
  padding-bottom: 0.5rem;
}

.user-history-chat,
.bot-history-chat {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(21 21 23 / var(--tw-bg-opacity));
  padding: 0.75rem;
}

@media (min-width: 640px) {

  .user-history-chat,
.bot-history-chat {
    gap: 1rem;
    padding: 1rem;
  }
}
.bot-history-chat {
  margin-bottom: 1.25rem;
}
.query,
.response {
  max-width: 75%;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(205 205 205 / var(--tw-text-opacity));
}
@media (min-width: 640px) {

  .query,
.response {
    max-width: 80%;
  }
}

.bot-chat {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(21 21 23 / var(--tw-bg-opacity));
  padding: 0.5rem;
}

@media (min-width: 640px) {

  .bot-chat {
    padding: 1rem;
  }
}
.options {
  position: absolute;
  right: 0.5rem;
  --tw-text-opacity: 1;
  color: rgb(119 119 119 / var(--tw-text-opacity));
}
@media (min-width: 640px) {

  .options {
    right: 0.75rem;
  }
}
.lawyer-card-wrapper {
  margin-top: 2rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 0.25rem;
}
.lawyer-card {
  position: relative;
  display: flex;
  height: 22rem;
  width: 15rem;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(37 37 39 / var(--tw-bg-opacity));
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  --tw-shadow-color: #334155;
  --tw-shadow: var(--tw-shadow-colored);
}
.banner {
  min-height: 23%;
  width: 100%;
  --tw-bg-opacity: 1;
  background-color: rgb(51 65 85 / var(--tw-bg-opacity));
}
.lawyer-img {
  position: absolute;
  left: 50%;
  top: 2rem;
  z-index: 10;
  height: 5rem;
  width: 5rem;
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(15 23 42 / var(--tw-bg-opacity));
  object-fit: contain;
}
@media (min-width: 640px) {

  .lawyer-img {
    height: 6rem;
    width: 6rem;
  }
}
.card-details {
  margin-top: 3.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
}
@media (min-width: 640px) {

  .card-details {
    padding: 0.5rem;
  }
}
.card-detail {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.25rem;
  text-align: right;
}

.refresh-btn {
  position: absolute;
  bottom: 3.5rem;
  left: 50%;
  margin-bottom: 1.25rem;
  display: flex;
  width: max-content;
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  align-items: center;
  gap: 0.25rem;
  --tw-border-opacity: 1;
  border-color: rgb(56 56 56 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(26 26 26 / var(--tw-bg-opacity));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

@media (min-width: 640px) {

  .refresh-btn {
    margin-bottom: 1.5rem;
  }
}

@media (min-width: 768px) {

  .refresh-btn {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
/*  */
.sidebar-wrapper {
  display: flex;
  height: 0px;
  max-height: 100vh;
  width: 0px;
  --tw-translate-x: -500px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
  overflow: auto;
  --tw-bg-opacity: 1;
  background-color: rgb(27 27 27 / var(--tw-bg-opacity));
  padding: 0.25rem;
  font-size: 15px;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
@media (min-width: 640px) {

  .sidebar-wrapper {
    height: auto;
    min-width: 250px;
    --tw-translate-x: -0px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
}
@media (min-width: 768px) {

  .sidebar-wrapper {
    min-width: 290px;
  }
}

.sidebar-mobile-wrapper {
  position: absolute;
  z-index: 40;
  height: 100vh;
  width: 97%;
  --tw-backdrop-blur: blur(3px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

@media (min-width: 640px) {

  .sidebar-mobile-wrapper {
    --tw-translate-x: -5000px;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  }
}
.sidebar-mobile {
  position: absolute;
  display: flex;
  height: 100%;
  width: 275px;
  flex-direction: column;
  justify-content: space-between;
  gap: 1rem;
  overflow: auto;
  --tw-bg-opacity: 1;
  background-color: rgb(20 20 20 / var(--tw-bg-opacity));
  padding: 0.25rem;
  padding-right: 0.75rem;
  font-size: 15px;
}
.close-sidebar {
  position: absolute;
  right: 0px;
  margin: 0.25rem;
  cursor: pointer;
}
.sidebar-crumbs {
  margin: 0.5rem;
}
.user-name-sidebar {
  text-transform: capitalize;
}

.head-title {
  width: 100%;
  text-align: center;
  font-size: 1.5rem;
  line-height: 2rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  --tw-text-opacity: 1;
  color: rgb(233 254 83 / var(--tw-text-opacity));
}

.logo-text {
  font-family: "Poltawski Nowy";
}
.nav-item {
  display: flex;
  width: 100%;
  cursor: pointer;
  align-items: center;
  gap: 0.75rem;
  border-radius: 0.25rem;
  padding: 0.75rem;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.nav-item:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(28 29 35 / var(--tw-bg-opacity));
}
.nav-text {
  font-weight: 500;
  letter-spacing: 0.025em;
}
.new-chat-btn,
.view-profile-btn,
.recommend-btn,
.signup-btn,
.signin-btn {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  border-radius: 0.25rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(233 254 83 / var(--tw-border-opacity));
  background-color: transparent;
  padding: 0.5rem;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(233 254 83 / var(--tw-text-opacity));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.new-chat-btn:hover,
.view-profile-btn:hover,
.recommend-btn:hover,
.signup-btn:hover,
.signin-btn:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(233 254 83 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.recommend-btn {
  margin-right: 30px;
}

/* .recentBox {
  @apply max-h-[160px] md:max-h-[168px] lg:max-h-[180px] xl:max-h-[240px] 2xl:max-h-[400px] 3xl:max-h-[530px] overflow-auto;
} */
.recentItem {
  cursor: pointer;
  border-radius: 0.25rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}
.recentItem:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(28 29 35 / var(--tw-bg-opacity));
}
/* .sidebar-lower {
  @apply lg:absolute w-full lg:bottom-1;
} */
.user-card {
  position: relative;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 5px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(69 69 69 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(29 29 29 / var(--tw-bg-opacity));
  padding: 0.75rem;
}
.drop {
  position: absolute;
  bottom: 3.8rem;
  right: 0.5rem;
  z-index: 20;
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  border-radius: 0.25rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(69 69 69 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(29 29 29 / var(--tw-bg-opacity));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
@media (min-width: 768px) {

  .drop {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
.logout-btn {
  display: flex;
  width: max-content;
  gap: 0.25rem;
  border-radius: 0.25rem;
}

/*  */

.lawyerlist-wrapper {
  display: flex;
  max-width: 100%;
  flex-direction: column;
  gap: 1rem;
  padding: 0.25rem;
}

@media (min-width: 640px) {

  .lawyerlist-wrapper {
    padding: 1rem;
  }
}
.lawyers-input-wrapper {
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  padding-left: 2rem;
  padding-right: 2rem;
}
@media (min-width: 640px) {

  .lawyers-input-wrapper {
    width: 24rem;
    padding-left: 2rem;
    padding-right: 2rem;
  }
}
.lawyer-search-input,
.signup-input,
.signin-input {
  width: 100%;
  border-radius: 4px;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(70 70 70 / var(--tw-border-opacity));
  background-color: transparent;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 2rem;
}
.search-icon {
  position: absolute;
  top: 50%;
  left: 2.5rem;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.selectLawyer-btns {
  margin-top: 1.5rem;
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem;
}

@media (min-width: 640px) {

  .selectLawyer-btns {
    padding: 1rem;
  }
}
.selectLawyer-btn {
  border-radius: 0.25rem;
  padding: 0.75rem;
  --tw-text-opacity: 1;
  color: rgb(214 214 214 / var(--tw-text-opacity));
}
.selectLawyer-btn:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(28 29 35 / var(--tw-bg-opacity));
}
.table-wrapper {
  display: flex;
  max-height: calc(98vh - 225px);
  flex-direction: column;
  overflow: scroll;
  --tw-bg-opacity: 1;
  background-color: rgb(20 20 22 / var(--tw-bg-opacity));
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
@media (min-width: 640px) {

  .table-wrapper {
    padding: 1.25rem;
  }
}
.lawyer-detail {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
@media (min-width: 640px) {

  .lawyer-detail>*:nth-child(3) {
    min-width: 280px;
  }
}

.table-col {
  display: flex;
  min-width: 170px;
  max-width: 120px;
  flex-direction: column;
  gap: 0.25rem;
  overflow-wrap: break-word;
}

@media (min-width: 640px) {

  .table-col {
    max-width: 140px;
  }
}

/* LawyerProfile */

.lawyer-profile-wrapper,
.appointment-wrapper {
  display: flex;
  max-height: 85vh;
  flex-direction: column;
  gap: 1rem;
  overflow: auto;
  padding: 0.25rem;
  letter-spacing: 0.025em;
}

@media (min-width: 640px) {

  .lawyer-profile-wrapper,
.appointment-wrapper {
    max-height: 98vh;
  }
}

@media (min-width: 1024px) {

  .lawyer-profile-wrapper,
.appointment-wrapper {
    padding: 1rem;
  }
}
.lawyer-profile-box {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(21 21 23 / var(--tw-bg-opacity));
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
@media (min-width: 1024px) {

  .lawyer-profile-box {
    padding-left: 4rem;
    padding-right: 4rem;
  }
}

.profile {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

@media (min-width: 640px) {

  .profile {
    flex-direction: row;
  }
}

@media (min-width: 768px) {

  .profile {
    margin-left: 2.5rem;
  }
}
.basic-details {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  text-align: center;
}
@media (min-width: 640px) {

  .basic-details {
    align-items: flex-start;
    text-align: start;
  }
}
.other-details {
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
@media (min-width: 640px) {

  .other-details {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
@media (min-width: 1024px) {

  .other-details {
    gap: 1rem;
  }
}
.detail {
  gap: 0.25rem;
}

/* Appointment */
.appointment-wrapper {
  position: relative;
  height: 100%;
}
.head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
  padding-left: 2rem;
  padding-right: 2rem;
}
@media (min-width: 640px) {

  .head {
    padding: 1rem;
  }
}
.book-appointment-btn,
.landing-login-btn {
  width: max-content;
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(233 254 83 / var(--tw-bg-opacity));
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(34 34 34 / var(--tw-text-opacity));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.book-appointment-btn:hover,
.landing-login-btn:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.book-appointment-btn:active,
.landing-login-btn:active {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@media (min-width: 640px) {

  .book-appointment-btn,
.landing-login-btn {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
.appointment-coming-soon {
  position: absolute;
  inset: 0px;
  z-index: 20;
  height: 100vh;
  width: 100%;
  --tw-backdrop-blur: blur(2px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.coming-soon-wrapper {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  height: 100%;
  width: 90%;
  align-items: center;
  justify-content: center;
}

.animated-text {
  background: linear-gradient(135deg, #14ff89, #ffe600, #00ff1e);
  letter-spacing: 1px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: animate 1s linear infinite;
  padding: 20px;
}

@keyframes animate {
  100% {
    filter: hue-rotate(360deg);
  }
}

/* Signup */
.signup-wrapper,
.signin-wrapper {
  display: flex;
  min-height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
}
@media (min-width: 640px) {

  .signup-wrapper,
.signin-wrapper {
    padding: 1rem;
  }
}
.signup-input-wrapper,
.signin-input-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
}
.signup-icon,
.signin-icon {
  position: absolute;
  top: 50%;
  left: 0.5rem;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.form-wrapper {
  display: flex;
  width: 90%;
  max-width: 48rem;
  flex-direction: column-reverse;
  align-items: center;
  gap: 0.75rem;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(29 29 29 / var(--tw-bg-opacity));
  padding: 0.5rem;
}
@media (min-width: 640px) {

  .form-wrapper {
    flex-direction: row;
    gap: 1.5rem;
    padding: 1rem;
  }
}
@media (min-width: 768px) {

  .form-wrapper {
    width: 80%;
  }
}
@media (min-width: 1024px) {

  .form-wrapper {
    width: 70%;
  }
}
@media (min-width: 1280px) {

  .form-wrapper {
    width: 60%;
  }
}
.signup-form,
.signin-form {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 1rem;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(29 29 29 / var(--tw-bg-opacity));
  padding: 1rem;
}
@media (min-width: 640px) {

  .signup-form,
.signin-form {
    width: 80%;
    padding: 2rem;
  }
}

.signup-input,
.signin-input,
.lawyer-search-input {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.signup-input:focus,
.signin-input:focus,
.lawyer-search-input:focus {
  border-color: transparent;
  outline-width: 0.2px;
  outline-color: #E9FE53;
}
.signin-info,
.signup-info {
  width: 100%;
  text-align: right;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(233 254 83 / var(--tw-text-opacity));
}

.signup-img {
  display: none;
}

@media (min-width: 640px) {

  .signup-img {
    display: flex;
  }
}

.link {
  cursor: pointer;
  --tw-border-opacity: 1;
  border-bottom-color: rgb(233 254 83 / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(96 165 250 / var(--tw-text-opacity));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.link:hover {
  border-bottom-width: 1px;
  --tw-text-opacity: 1;
  color: rgb(216 180 254 / var(--tw-text-opacity));
}
.error-message {
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
/*  */
.appointment-book-wrapper {
  height: 100%;
  width: 100%;
  padding: 0.25rem;
}
@media (min-width: 640px) {

  .appointment-book-wrapper {
    padding: 1rem;
  }
}

/* Prompts */
.prompts-wrapper {
  margin-left: auto;
  margin-right: auto;
  margin-top: 1.5rem;
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  overflow: auto;
  padding: 0.5rem;
  text-align: center;
  font-size: 0.875rem;
  line-height: 1.25rem;
}
@media (min-width: 1024px) {

  .prompts-wrapper {
    width: 80%;
    font-size: 1rem;
    line-height: 1.5rem;
  }
}
.title {
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-size: 1.875rem;
  line-height: 2.25rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  --tw-text-opacity: 1;
  color: rgb(233 254 83 / var(--tw-text-opacity));
}
.prompt-box {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.prompt {
  cursor: pointer;
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(29 29 29 / var(--tw-bg-opacity));
  padding: 0.75rem;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.prompt:hover {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
/*  */
/* ?toggler */
.toggler {
  position: fixed;
  z-index: 50;
  display: flex;
  width: 100%;
  cursor: pointer;
  align-items: center;
  padding: 0.5rem;
}
@media (min-width: 640px) {

  .toggler {
    display: none;
  }
}
.header {
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-bottom-color: rgb(29 29 29 / var(--tw-border-opacity));
  --tw-backdrop-blur: blur(5px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
/*  */
.landingPage-wrapper {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  height: 100%;
  width: 100%;
  -webkit-user-select: none;
          user-select: none;
}
.landing-nav {
  position: fixed;
  left: 0px;
  right: 0px;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-bottom-color: rgb(233 254 83 / var(--tw-border-opacity));
  background-color: rgb(17 17 17 / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.4;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  --tw-backdrop-blur: blur(10px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
@media (min-width: 640px) {

  .landing-nav {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
@media (min-width: 768px) {

  .landing-nav {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
@media (min-width: 1024px) {

  .landing-nav {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}
.landing-login-btn {
  display: none;
}
@media (min-width: 640px) {

  .landing-login-btn {
    display: flex;
  }
}
.nav-dropdown {
  position: absolute;
  right: 0.5rem;
  top: 4rem;
  z-index: 50;
  display: flex;
  width: 150px;
  animation: fadeIn;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(37 37 39 / var(--tw-bg-opacity));
  padding: 1rem;
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
@media (min-width: 640px) {

  .nav-dropdown {
    display: none;
  }
}
.nav-dropdown {
  animation: fadeIn 0.4s ease-in-out;
}
@keyframes fadeIn {
  from {
    transform: translateY(20px);
    opacity: 0.8;
  }
  to {
    opacity: 1;
  }
}
.lists {
  width: 100%;
  cursor: pointer;
  border-radius: 0.25rem;
  text-align: center;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.lists:hover {
  --tw-text-opacity: 1;
  color: rgb(233 254 83 / var(--tw-text-opacity));
}
.lists:active {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.landing-login-btn-mobile {
  width: 100%;
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(233 254 83 / var(--tw-bg-opacity));
  padding: 0.5rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(34 34 34 / var(--tw-text-opacity));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.landing-login-btn-mobile:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.landing-login-btn-mobile:active {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hero {
  position: relative;
  margin-top: 5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-attachment: fixed;
  padding: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  line-height: 2.5rem;
  letter-spacing: 0.025em;
}
@media (min-width: 640px) {

  .hero {
    margin-top: 1rem;
    min-height: 98vh;
    flex-direction: row;
    gap: 5rem;
    padding-left: 1rem;
  }
}
@media (min-width: 768px) {

  .hero {
    padding-left: 1.5rem;
  }
}
@media (min-width: 1024px) {

  .hero {
    padding-left: 2rem;
  }
}
.hero-title {
  z-index: 30;
  display: flex;
  max-width: 42rem;
  flex-direction: column;
  gap: 0.75rem;
  border-radius: 0.5rem;
  --tw-backdrop-blur: blur(1px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
@media (min-width: 640px) {

  .hero-title {
    gap: 1.5rem;
  }
}
@media (min-width: 1536px) {

  .hero-title {
    margin-left: 6rem;
  }
}
.hero-img-wrapper {
  height: 45vh;
  overflow: hidden;
  border-radius: 0.375rem;
  border-width: 2.5px;
  border-style: solid;
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
  opacity: 0.75;
}
@media (min-width: 640px) {

  .hero-img-wrapper {
    position: absolute;
    right: -200px;
    height: 70vh;
  }
}
.hero-img-wrapper img {
  height: 100%;
  width: 100%;
  object-fit: contain;
}
@media (min-width: 640px) {

  .hero-img-wrapper img {
    object-fit: cover;
  }
}
.tryNow-btn {
  width: 100%;
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(233 254 83 / var(--tw-bg-opacity));
  padding-left: 1rem;
  padding-right: 1rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(34 34 34 / var(--tw-text-opacity));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.tryNow-btn:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.tryNow-btn:active {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@media (min-width: 640px) {

  .tryNow-btn {
    width: max-content;
  }
}
.try-connect-wrapper {
  position: absolute;
  inset: 0px;
  z-index: 20;
  display: grid;
  height: 100%;
  width: 100%;
  place-content: center;
  --tw-backdrop-blur: blur(3px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.try-connect-btn {
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(233 254 83 / var(--tw-bg-opacity));
  padding-top: 1rem;
  padding-bottom: 1rem;
  padding-left: 3rem;
  padding-right: 3rem;
  font-weight: 600;
  --tw-text-opacity: 1;
  color: rgb(34 34 34 / var(--tw-text-opacity));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.try-connect-btn:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.try-connect-btn:active {
  --tw-scale-x: .95;
  --tw-scale-y: .95;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@media (min-width: 640px) {

  .try-connect-btn {
    width: max-content;
  }
}

.matrix-bg {
  position: absolute;
  inset: 0px;
}
.matrix-bg-img {
  height: 100%;
}

.try-live-section {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.25rem;
  padding-left: 1rem;
  padding-right: 1rem;
  text-align: center;
}

@media (min-width: 640px) {

  .try-live-section {
    margin-top: 5rem;
    margin-bottom: 5rem;
    gap: 2rem;
  }
}
.try-chat-box {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 5rem;
  height: 75vh;
  width: 90%;
  overflow: auto;
  line-height: 1.5rem;
  letter-spacing: 0.025em;
}
@media (min-width: 768px) {

  .try-chat-box {
    width: 85%;
  }
}
.try-gpt-box {
  position: relative;
  min-height: 80vh;
  border-radius: 0.5rem;
  text-align: left;
  --tw-shadow: 0 0 20px 0px rgba(255, 255, 0, 0.4);
  --tw-shadow-colored: 0 0 20px 0px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.try-gpt-title {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  text-align: center;
}
@media (min-width: 640px) {

  .try-gpt-title {
    gap: 1.5rem;
    padding-top: 2rem;
    padding-bottom: 2rem;
    text-align: start;
  }
}

.feature-section {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 2.5rem;
}

@media (min-width: 640px) {

  .feature-section {
    margin-top: 2.5rem;
    gap: 2.5rem;
  }
}

@media (min-width: 768px) {

  .feature-section {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

@media (min-width: 1024px) {

  .feature-section {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}
.feature-boxes {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.5rem;
}
@media (min-width: 640px) {

  .feature-boxes {
    flex-direction: row;
    gap: 1rem;
  }
}
@media (min-width: 1024px) {

  .feature-boxes {
    height: 580px;
  }
}
.feature-box {
  position: relative;
  display: flex;
  max-width: 32rem;
  flex-direction: column;
  gap: 0.75rem;
  overflow: hidden;
  border-radius: 0.75rem;
  --tw-bg-opacity: 1;
  background-color: rgb(29 29 29 / var(--tw-bg-opacity));
  text-align: left;
}
@media (min-width: 768px) {

  .feature-box {
    gap: 1.25rem;
  }
}
.feature-box-pattern {
  position: absolute;
  top: 0px;
  right: 0px;
  height: 30%;
  width: 30%;
}
.feature-title {
  z-index: 10;
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 1rem;
  padding: 0.75rem;
}
@media (min-width: 640px) {

  .feature-title {
    width: 80%;
    gap: 1.5rem;
    padding: 1.5rem;
  }
}
.feature-box-pattern-img {
  height: 100%;
  width: 100%;
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  object-fit: contain;
}
.feature-box-img {
  bottom: 0px;
  opacity: 0.95;
}
@media (min-width: 768px) {

  .feature-box-img {
    position: absolute;
  }
}

.feature-side-gradient,
.feature-card-side-gradient {
  width: 100%;
  height: 150px;
  background: linear-gradient(
    90deg,
    #e9fe53 -136.68%,
    rgba(233, 254, 83, 0) 187.68%
  );
  filter: blur(200px);
  position: absolute;
  left: -400px;
  top: 50%;
  display: none;
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@media (min-width: 640px) {

  .feature-side-gradient,
.feature-card-side-gradient {
    display: flex;
  }
}
.feature-cards {
  position: relative;
  display: flex;
  max-height: 100%;
  flex-direction: column;
  gap: 0.75rem;
}
.feature-card-side-gradient {
  position: absolute;
  inset: 0px;
  top: 50%;
  right: -200px;
  display: flex;
  height: 200px;
  opacity: 0.9;
}
.feature-card {
  z-index: 20;
  height: 33.333333%;
  width: 100%;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(29 29 29 / var(--tw-bg-opacity));
  padding: 0.5rem;
  --tw-backdrop-blur: blur(5px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
@media (min-width: 768px) {

  .feature-card {
    max-width: 400px;
    padding: 1rem;
  }
}
@media (min-width: 1536px) {

  .feature-card {
    max-width: 500px;
  }
}
.card-icons {
  height: 2.5rem;
  width: 2.5rem;
}
@media (min-width: 1024px) {

  .card-icons {
    height: 3rem;
    width: 3rem;
  }
}
.perfect-for-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-top: 1.5rem;
}
@media (min-width: 640px) {

  .perfect-for-section {
    padding-top: 3rem;
  }
}
.perfect-for-box {
  background-size: 100% 100%;
  display: flex;
  gap: 1rem;
  overflow: auto;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  padding-top: 3rem;
  padding-bottom: 3rem;
  padding-left: 1rem;
  padding-right: 1rem;
}
@media (min-width: 640px) {

  .perfect-for-box {
    padding-top: 6rem;
    padding-bottom: 6rem;
  }
}
@media (min-width: 1024px) {

  .perfect-for-box {
    justify-content: center;
  }
}

.perfect-for-icon-img {
  margin-left: auto;
  margin-right: auto;
  height: 3.5rem;
  width: 3.5rem;
  object-fit: contain;
  text-align: center;
  opacity: 0.7;
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.box-card {
  z-index: 10;
  display: flex;
  min-height: 270px;
  min-width: 350px;
  max-width: 360px;
  flex-direction: column;
  gap: 0.75rem;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(29 29 29 / var(--tw-bg-opacity));
  padding: 0.75rem;
}
@media (min-width: 640px) {

  .box-card {
    padding: 1.5rem;
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
}

.try-gpt-bookDemo {
  display: grid;
  place-items: center;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  padding-top: 3rem;
  padding-bottom: 3rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

@media (min-width: 640px) {

  .try-gpt-bookDemo {
    padding-top: 4rem;
    padding-bottom: 4rem;
  }
}
.landing-footer {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
@media (min-width: 640px) {

  .landing-footer {
    gap: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
@media (min-width: 768px) {

  .landing-footer {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}
@media (min-width: 1024px) {

  .landing-footer {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}
.footer-upper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}
@media (min-width: 640px) {

  .footer-upper {
    flex-direction: row;
  }
}
.footer-lower {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.landingPage-wrapper ul li {
  cursor: pointer;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.landingPage-wrapper ul li:hover {
  --tw-text-opacity: 1;
  color: rgb(233 254 83 / var(--tw-text-opacity));
}
.separator {
  margin-left: auto;
  margin-right: auto;
  height: 2px;
  width: 90%;
  border-radius: 100%;
  --tw-bg-opacity: 1;
  background-color: rgb(233 254 83 / var(--tw-bg-opacity));
  opacity: 0.5;
}

/*  */
.bookDemo-wrapper {
  display: flex;
  width: 90%;
  max-width: 48rem;
  flex-direction: column;
  gap: 1rem;
  border-radius: 0.5rem;
  --tw-bg-opacity: 1;
  background-color: rgb(29 29 29 / var(--tw-bg-opacity));
  padding: 0.75rem;
}
@media (min-width: 640px) {

  .bookDemo-wrapper {
    flex-direction: row;
  }
}
@media (min-width: 768px) {

  .bookDemo-wrapper {
    width: 80%;
    padding-left: 1.5rem;
    padding-right: 1.5rem;
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
}
@media (min-width: 1024px) {

  .bookDemo-wrapper {
    width: 70%;
  }
}
@media (min-width: 1280px) {

  .bookDemo-wrapper {
    width: 60%;
  }
}

.bookDemo-form {
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 1rem;
  padding: 0.25rem;
}

@media (min-width: 640px) {

  .bookDemo-form {
    padding: 0px;
  }
}
.bookDemo-btn {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  width: 100%;
  border-radius: 0.25rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(233 254 83 / var(--tw-border-opacity));
  background-color: transparent;
  padding: 0.5rem;
  font-weight: 700;
  --tw-text-opacity: 1;
  color: rgb(233 254 83 / var(--tw-text-opacity));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.bookDemo-btn:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(233 254 83 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
@media (min-width: 640px) {

  .bookDemo-btn {
    width: max-content;
  }
}

/*  */

/* utils */
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(233 254 83 / var(--tw-bg-opacity));
}
.bg-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(28 29 35 / var(--tw-bg-opacity));
}

.text-primary {
  --tw-text-opacity: 1;
  color: rgb(233 254 83 / var(--tw-text-opacity));
}

.text-secondary {
  --tw-text-opacity: 1;
  color: rgb(183 183 183 / var(--tw-text-opacity));
}
.text-light {
  --tw-text-opacity: 1;
  color: rgb(177 177 177 / var(--tw-text-opacity));
}
.text-footer {
  --tw-text-opacity: 1;
  color: rgb(61 61 61 / var(--tw-text-opacity));
}
.border-light {
  --tw-border-opacity: 1;
  border-color: rgb(54 54 54 / var(--tw-border-opacity));
}
.border-primary {
  --tw-border-opacity: 1;
  border-color: rgb(233 254 83 / var(--tw-border-opacity));
}

/* .blur-text {
  @apply blur-[2px];
} */
.s-p {
  cursor: pointer;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
@media (min-width: 768px) {

  .s-p {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
}
@media (min-width: 1024px) {

  .s-p {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

.flxCol {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.text-para {
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(168 168 168 / var(--tw-text-opacity));
}

.icons {
  height: 1rem;
  cursor: pointer;
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.icons:active {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.sidebar-icons {
  height: 1.5rem;
}

.back-btn-wrapper {
  display: none;
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

@media (min-width: 640px) {

  .back-btn-wrapper {
    display: flex;
  }
}

/*  */
.filter-logo {
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.bg-overlay {
  position: absolute;
  inset: 0px;
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
  opacity: 0.3;
  --tw-backdrop-blur: blur(4px);
  -webkit-backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
          backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}

.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

@media (min-width: 640px) {

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-14 {
    height: 3.5rem;
  }

  .sm\\:h-52 {
    height: 13rem;
  }

  .sm\\:h-\\[300px\\] {
    height: 300px;
  }

  .sm\\:max-h-\\[98vh\\] {
    max-height: 98vh;
  }

  .sm\\:w-14 {
    width: 3.5rem;
  }

  .sm\\:\\!text-base {
    font-size: 1rem !important;
    line-height: 1.5rem !important;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-6xl {
    font-size: 3.75rem;
    line-height: 1;
  }

  .sm\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

@media (min-width: 768px) {

  .md\\:right-16 {
    right: 4rem;
  }

  .md\\:h-\\[420px\\] {
    height: 420px;
  }

  .md\\:w-32 {
    width: 8rem;
  }

  .md\\:w-36 {
    width: 9rem;
  }

  .md\\:gap-4 {
    gap: 1rem;
  }

  .md\\:gap-6 {
    gap: 1.5rem;
  }

  .md\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }
}

@media (min-width: 1024px) {

  .lg\\:right-5 {
    right: 1.25rem;
  }

  .lg\\:h-\\[500px\\] {
    height: 500px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;CAAc;;AAAd;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,4NAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd;AAAc;AAEd;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,yBAAmB;UAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gKAAmB;EAAnB,wJAAmB;EAAnB,iLAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;;AAEnB;EACE,wBAAwB;EACxB,uBAAuB;EACvB,kCAAkC;EAClC;;;;;GAKC,EAAE,iDAAiD;AACtD;;AAEA,0CAA0C;AAC1C;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAGE;EAAA,aAAqE;EAArE,iBAAqE;EAArE,gBAAqE;EAArE,kBAAqE;EAArE,sDAAqE;EAArE,oBAAqE;EAArE;AAAqE;AAEvE,iBAAiB;AAGf;;EAAA,kBAAwD;EAAxD,gBAAwD;EAAxD,WAAwD;EAAxD,cAAwD;EAAxD,aAAwD;EAAxD;AAAwD;;AAIxD;EAAA,iBAAmI;EAAnI,kBAAmI;EAAnI,sBAAmI;EAAnI,+BAAmI;EAAnI,UAAmI;EAAnI,cAAmI;EAAnI,mBAAmI;EAAnI;AAAmI;;AAAnI;;EAAA;IAAA;EAAmI;AAAA;;AAAnI;;EAAA;IAAA;EAAmI;AAAA;;AAInI;EAAA,kBAAsF;EAAtF,SAAsF;EAAtF,WAAsF;EAAtF,sBAAsF;EAAtF,UAAsF;EAAtF,sBAAsF;EAAtF;AAAsF;;AAAtF;;EAAA;IAAA;EAAsF;AAAA;;AAAtF;;EAAA;IAAA;EAAsF;AAAA;AAGtF;EAAA,YAAqH;EAArH,WAAqH;EAArH,iBAAqH;EAArH,sBAAqH;EAArH,sDAAqH;EAArH,kBAAqH;EAArH,sDAAqH;EAArH,oBAAqH;EAArH,mBAAqH;EAArH,sBAAqH;EAArH,qBAAqH;EAArH,8BAAqH;EAArH;AAAqH;AAArH;;EAAA;IAAA,kBAAqH;IAArH;EAAqH;AAAA;AAGrH;EAAA,kBAAsC;EAAtC,cAAsC;EAAtC,QAAsC;EAAtC;AAAsC;AAItC;;EAAA,kBAAoD;EAApD,WAAoD;EAApD,QAAoD;EAApD,sBAAoD;EAApD;AAAoD;AAGpD;EAAA,gBAA6E;EAA7E,qBAA6E;EAA7E,aAA6E;EAA7E,WAA6E;EAA7E,sBAA6E;EAA7E,WAA6E;EAA7E,cAA6E;EAA7E;AAA6E;AAG7E;EAAA,kBAAuE;EAAvE,aAAuE;EAAvE,uBAAuE;EAAvE,YAAuE;EAAvE,kBAAuE;EAAvE,sDAAuE;EAAvE;AAAuE;AAAvE;;EAAA;IAAA,SAAuE;IAAvE;EAAuE;AAAA;AAGvE;EAAA,aAAmD;EAAnD,uBAAmD;EAAnD,YAAmD;EAAnD,kBAAmD;EAAnD;AAAmD;AAAnD;;EAAA;IAAA;EAAmD;AAAA;;AAInD;EAAA,kBAAwE;EAAxE,qBAAwE;EAAxE,aAAwE;EAAxE,WAAwE;EAAxE,sBAAwE;EAAxE,WAAwE;EAAxE,cAAwE;EAAxE;AAAwE;AAGxE;EAAA,kBAA0D;EAA1D,mBAA0D;EAA1D,aAA0D;EAA1D,sBAA0D;EAA1D,WAA0D;EAA1D,kBAA0D;EAA1D,sDAA0D;EAA1D;AAA0D;;AAK1D;;EAAA,kBAAwE;EAAxE,aAAwE;EAAxE,uBAAwE;EAAxE,YAAwE;EAAxE,kBAAwE;EAAxE,sDAAwE;EAAxE;AAAwE;;AAAxE;;EAAA;;IAAA,SAAwE;IAAxE;EAAwE;AAAA;AAGxE;EAAA;AAAW;AAIX;;EAAA,cAAwD;EAAxD,mBAAwD;EAAxD,oBAAwD;EAAxD,oBAAwD;EAAxD;AAAwD;AAAxD;;EAAA;;IAAA;EAAwD;AAAA;;AAIxD;EAAA,kBAA2D;EAA3D,aAA2D;EAA3D,sBAA2D;EAA3D,WAA2D;EAA3D,kBAA2D;EAA3D,sDAA2D;EAA3D;AAA2D;;AAA3D;;EAAA;IAAA;EAA2D;AAAA;AAG3D;EAAA,kBAAiD;EAAjD,aAAiD;EAAjD,oBAAiD;EAAjD;AAAiD;AAAjD;;EAAA;IAAA;EAAiD;AAAA;AAGjD;EAAA,gBAAgE;EAAhE,aAAgE;EAAhE,eAAgE;EAAhE,mBAAgE;EAAhE,uBAAgE;EAAhE,YAAgE;EAAhE;AAAgE;AAGhE;EAAA,kBAAoI;EAApI,aAAoI;EAApI,aAAoI;EAApI,YAAoI;EAApI,sBAAoI;EAApI,8BAAoI;EAApI,gBAAoI;EAApI,qBAAoI;EAApI,kBAAoI;EAApI,sDAAoI;EAApI,6EAAoI;EAApI,iGAAoI;EAApI,uGAAoI;EAApI,0BAAoI;EAApI;AAAoI;AAGpI;EAAA,eAAsC;EAAtC,WAAsC;EAAtC,kBAAsC;EAAtC;AAAsC;AAGtC;EAAA,kBAA2H;EAA3H,SAA2H;EAA3H,SAA2H;EAA3H,WAA2H;EAA3H,YAA2H;EAA3H,WAA2H;EAA3H,sBAA2H;EAA3H,+LAA2H;EAA3H,qBAA2H;EAA3H,kBAA2H;EAA3H,sDAA2H;EAA3H;AAA2H;AAA3H;;EAAA;IAAA,YAA2H;IAA3H;EAA2H;AAAA;AAG3H;EAAA,kBAAmE;EAAnE,aAAmE;EAAnE,sBAAmE;EAAnE,8BAAmE;EAAnE,YAAmE;EAAnE,gBAAmE;EAAnE,kBAAmE;EAAnE;AAAmE;AAAnE;;EAAA;IAAA;EAAmE;AAAA;AAGnE;EAAA,aAAwD;EAAxD,uBAAwD;EAAxD,8BAAwD;EAAxD,YAAwD;EAAxD;AAAwD;;AAIxD;EAAA,kBAAkJ;EAAlJ,cAAkJ;EAAlJ,SAAkJ;EAAlJ,sBAAkJ;EAAlJ,aAAkJ;EAAlJ,kBAAkJ;EAAlJ,sBAAkJ;EAAlJ,+LAAkJ;EAAlJ,mBAAkJ;EAAlJ,YAAkJ;EAAlJ,sBAAkJ;EAAlJ,sDAAkJ;EAAlJ,kBAAkJ;EAAlJ,sDAAkJ;EAAlJ,qBAAkJ;EAAlJ,sBAAkJ;EAAlJ,mBAAkJ;EAAlJ;AAAkJ;;AAAlJ;;EAAA;IAAA;EAAkJ;AAAA;;AAAlJ;;EAAA;IAAA,oBAAkJ;IAAlJ;EAAkJ;AAAA;AAEpJ,KAAK;AAEH;EAAA,aAA6M;EAA7M,WAA6M;EAA7M,iBAA6M;EAA7M,UAA6M;EAA7M,wBAA6M;EAA7M,+LAA6M;EAA7M,sBAA6M;EAA7M,8BAA6M;EAA7M,SAA6M;EAA7M,cAA6M;EAA7M,kBAA6M;EAA7M,sDAA6M;EAA7M,gBAA6M;EAA7M,eAA6M;EAA7M,wBAA6M;EAA7M,wDAA6M;EAA7M;AAA6M;AAA7M;;EAAA;IAAA,YAA6M;IAA7M,gBAA6M;IAA7M,sBAA6M;IAA7M;EAA6M;AAAA;AAA7M;;EAAA;IAAA;EAA6M;AAAA;;AAI7M;EAAA,kBAAkH;EAAlH,WAAkH;EAAlH,aAAkH;EAAlH,UAAkH;EAAlH,6BAAkH;EAAlH,+QAAkH;UAAlH,uQAAkH;EAAlH,wBAAkH;EAAlH,wDAAkH;EAAlH;AAAkH;;AAAlH;;EAAA;IAAA,yBAAkH;IAAlH;EAAkH;AAAA;AAGlH;EAAA,kBAAoH;EAApH,aAAoH;EAApH,YAAoH;EAApH,YAAoH;EAApH,sBAAoH;EAApH,8BAAoH;EAApH,SAAoH;EAApH,cAAoH;EAApH,kBAAoH;EAApH,sDAAoH;EAApH,gBAAoH;EAApH,sBAAoH;EAApH;AAAoH;AAGpH;EAAA,kBAA0C;EAA1C,UAA0C;EAA1C,eAA0C;EAA1C;AAA0C;AAG1C;EAAA;AAAU;AAGV;EAAA;AAAiB;;AAIjB;EAAA,WAA0E;EAA1E,kBAA0E;EAA1E,iBAA0E;EAA1E,iBAA0E;EAA1E,gBAA0E;EAA1E,sBAA0E;EAA1E,oBAA0E;EAA1E;AAA0E;;AAG5E;EACE,6BAA6B;AAC/B;AAEE;EAAA,aAAkG;EAAlG,WAAkG;EAAlG,eAAkG;EAAlG,mBAAkG;EAAlG,YAAkG;EAAlG,sBAAkG;EAAlG,gBAAkG;EAAlG,wBAAkG;EAAlG,wDAAkG;EAAlG;AAAkG;AAAlG;EAAA,kBAAkG;EAAlG;AAAkG;AAGlG;EAAA,gBAAgC;EAAhC;AAAgC;AAOhC;;;;;EAAA,kBAAyJ;EAAzJ,qBAAyJ;EAAzJ,iBAAyJ;EAAzJ,kBAAyJ;EAAzJ,WAAyJ;EAAzJ,sBAAyJ;EAAzJ,iBAAyJ;EAAzJ,sBAAyJ;EAAzJ,wDAAyJ;EAAzJ,6BAAyJ;EAAzJ,eAAyJ;EAAzJ,gBAAyJ;EAAzJ,oBAAyJ;EAAzJ,+CAAyJ;EAAzJ,wBAAyJ;EAAzJ,wDAAyJ;EAAzJ;AAAyJ;AAAzJ;;;;;EAAA,kBAAyJ;EAAzJ,wDAAyJ;EAAzJ,oBAAyJ;EAAzJ;AAAyJ;AAGzJ;EAAA;AAAgB;;AAGlB;;GAEG;AAED;EAAA,eAA0D;EAA1D,sBAA0D;EAA1D,mBAA0D;EAA1D,sBAA0D;EAA1D,qBAA0D;EAA1D;AAA0D;AAA1D;EAAA,kBAA0D;EAA1D;AAA0D;AAE5D;;GAEG;AAED;EAAA,kBAA6G;EAA7G,qBAA6G;EAA7G,aAA6G;EAA7G,mBAA6G;EAA7G,8BAA6G;EAA7G,kBAA6G;EAA7G,iBAA6G;EAA7G,sBAA6G;EAA7G,sDAA6G;EAA7G,kBAA6G;EAA7G,sDAA6G;EAA7G;AAA6G;AAG7G;EAAA,kBAAyK;EAAzK,cAAyK;EAAzK,aAAyK;EAAzK,WAAyK;EAAzK,aAAyK;EAAzK,eAAyK;EAAzK,mBAAyK;EAAzK,uBAAyK;EAAzK,YAAyK;EAAzK,sBAAyK;EAAzK,iBAAyK;EAAzK,sBAAyK;EAAzK,sDAAyK;EAAzK,kBAAyK;EAAzK,sDAAyK;EAAzK,qBAAyK;EAAzK,sBAAyK;EAAzK,mBAAyK;EAAzK,sBAAyK;EAAzK,mBAAyK;EAAzK;AAAyK;AAAzK;;EAAA;IAAA,oBAAyK;IAAzK;EAAyK;AAAA;AAGzK;EAAA,aAAgC;EAAhC,kBAAgC;EAAhC,YAAgC;EAAhC;AAAgC;;AAGlC,KAAK;;AAGH;EAAA,aAAgD;EAAhD,eAAgD;EAAhD,sBAAgD;EAAhD,SAAgD;EAAhD;AAAgD;;AAAhD;;EAAA;IAAA;EAAgD;AAAA;AAGhD;EAAA,kBAA6D;EAA7D,aAA6D;EAA7D,WAA6D;EAA7D,mBAA6D;EAA7D,kBAA6D;EAA7D;AAA6D;AAA7D;;EAAA;IAAA,YAA6D;IAA7D,kBAA6D;IAA7D;EAA6D;AAAA;AAK7D;;;EAAA,WAAkF;EAAlF,kBAAkF;EAAlF,iBAAkF;EAAlF,sBAAkF;EAAlF,sDAAkF;EAAlF,6BAAkF;EAAlF,mBAAkF;EAAlF,sBAAkF;EAAlF;AAAkF;AAGlF;EAAA,kBAA0D;EAA1D,QAA0D;EAA1D,YAA0D;EAA1D,sBAA0D;EAA1D;AAA0D;;AAI1D;EAAA,kBAAiC;EAAjC,aAAiC;EAAjC,WAAiC;EAAjC;AAAiC;;AAAjC;;EAAA;IAAA;EAAiC;AAAA;AAGjC;EAAA,sBAAoD;EAApD,gBAAoD;EAApD,oBAAoD;EAApD;AAAoD;AAApD;EAAA,kBAAoD;EAApD;AAAoD;AAGpD;EAAA,aAAsF;EAAtF,8BAAsF;EAAtF,sBAAsF;EAAtF,gBAAsF;EAAtF,kBAAsF;EAAtF,sDAAsF;EAAtF,mBAAsF;EAAtF;AAAsF;AAAtF;;EAAA;IAAA;EAAsF;AAAA;AAGtF;EAAA,aAA4E;EAA5E,mBAA4E;EAA5E,WAA4E;EAA5E,oBAA4E;EAA5E,qBAA4E;EAA5E,iBAA4E;EAA5E;AAA4E;AAA5E;;EAAA;IAAA;EAA4E;AAAA;;AAI5E;EAAA,aAAoF;EAApF,gBAAoF;EAApF,gBAAoF;EAApF,sBAAoF;EAApF,YAAoF;EAApF;AAAoF;;AAApF;;EAAA;IAAA;EAAoF;AAAA;;AAGtF,kBAAkB;;AAIhB;;EAAA,aAA8F;EAA9F,gBAA8F;EAA9F,sBAA8F;EAA9F,SAA8F;EAA9F,cAA8F;EAA9F,gBAA8F;EAA9F;AAA8F;;AAA9F;;EAAA;;IAAA;EAA8F;AAAA;;AAA9F;;EAAA;;IAAA;EAA8F;AAAA;AAG9F;EAAA,aAA0D;EAA1D,sBAA0D;EAA1D,WAA0D;EAA1D,kBAA0D;EAA1D,sDAA0D;EAA1D,mBAA0D;EAA1D,sBAA0D;EAA1D,oBAA0D;EAA1D;AAA0D;AAA1D;;EAAA;IAAA,kBAA0D;IAA1D;EAA0D;AAAA;;AAI1D;EAAA,aAA4D;EAA5D,sBAA4D;EAA5D,mBAA4D;EAA5D;AAA4D;;AAA5D;;EAAA;IAAA;EAA4D;AAAA;;AAA5D;;EAAA;IAAA;EAA4D;AAAA;AAG5D;EAAA,aAAgF;EAAhF,sBAAgF;EAAhF,mBAAgF;EAAhF,YAAgF;EAAhF;AAAgF;AAAhF;;EAAA;IAAA,uBAAgF;IAAhF;EAAgF;AAAA;AAGhF;EAAA,gBAA6D;EAA7D,aAA6D;EAA7D,sBAA6D;EAA7D,WAA6D;EAA7D,mBAA6D;EAA7D;AAA6D;AAA7D;;EAAA;IAAA,eAA6D;IAA7D;EAA6D;AAAA;AAA7D;;EAAA;IAAA;EAA6D;AAAA;AAG7D;EAAA;AAAY;;AAGd,gBAAgB;AAEd;EAAA,kBAAsB;EAAtB;AAAsB;AAGtB;EAAA,aAAwD;EAAxD,mBAAwD;EAAxD,8BAAwD;EAAxD,eAAwD;EAAxD,kBAAwD;EAAxD;AAAwD;AAAxD;;EAAA;IAAA;EAAwD;AAAA;AAIxD;;EAAA,kBAA+H;EAA/H,sBAA+H;EAA/H,kBAA+H;EAA/H,wDAA+H;EAA/H,mBAA+H;EAA/H,sBAA+H;EAA/H,oBAA+H;EAA/H,qBAA+H;EAA/H,gBAA+H;EAA/H,oBAA+H;EAA/H,6CAA+H;EAA/H,wBAA+H;EAA/H,wDAA+H;EAA/H;AAA+H;AAA/H;;EAAA,kBAA+H;EAA/H,kBAA+H;EAA/H;AAA+H;AAA/H;;EAAA,iBAA+H;EAA/H,iBAA+H;EAA/H;AAA+H;AAA/H;;EAAA;;IAAA,oBAA+H;IAA/H;EAA+H;AAAA;AAG/H;EAAA,kBAAkE;EAAlE,UAAkE;EAAlE,WAAkE;EAAlE,aAAkE;EAAlE,WAAkE;EAAlE,6BAAkE;EAAlE,+QAAkE;UAAlE;AAAkE;AAGlE;EAAA,kBAAuE;EAAvE,iBAAuE;EAAvE,kBAAuE;EAAvE,aAAuE;EAAvE,YAAuE;EAAvE,UAAuE;EAAvE,mBAAuE;EAAvE;AAAuE;;AAGzE;EACE,8DAA8D;EAC9D,mBAAmB;EACnB,6BAA6B;EAC7B,oCAAoC;EACpC,qCAAqC;EACrC,aAAa;AACf;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,WAAW;AAGT;;EAAA,aAAoE;EAApE,gBAAoE;EAApE,WAAoE;EAApE,mBAAoE;EAApE,uBAAoE;EAApE;AAAoE;AAApE;;EAAA;;IAAA;EAAoE;AAAA;AAIpE;;EAAA,kBAA6B;EAA7B,YAA6B;EAA7B;AAA6B;AAI7B;;EAAA,kBAAmD;EAAnD,QAAmD;EAAnD,YAAmD;EAAnD,sBAAmD;EAAnD;AAAmD;AAGnD;EAAA,aAA0J;EAA1J,UAA0J;EAA1J,gBAA0J;EAA1J,8BAA0J;EAA1J,mBAA0J;EAA1J,YAA0J;EAA1J,qBAA0J;EAA1J,kBAA0J;EAA1J,sDAA0J;EAA1J;AAA0J;AAA1J;;EAAA;IAAA,mBAA0J;IAA1J,WAA0J;IAA1J;EAA0J;AAAA;AAA1J;;EAAA;IAAA;EAA0J;AAAA;AAA1J;;EAAA;IAAA;EAA0J;AAAA;AAA1J;;EAAA;IAAA;EAA0J;AAAA;AAI1J;;EAAA,aAAiF;EAAjF,WAAiF;EAAjF,sBAAiF;EAAjF,SAAiF;EAAjF,uBAAiF;EAAjF,kBAAiF;EAAjF,sDAAiF;EAAjF;AAAiF;AAAjF;;EAAA;;IAAA,UAAiF;IAAjF;EAAiF;AAAA;;AAMjF;;;EAAA,8BAA0F;EAA1F;AAA0F;;AAA1F;;;EAAA,yBAA0F;EAA1F,oBAA0F;EAA1F;AAA0F;AAI1F;;EAAA,WAA+C;EAA/C,iBAA+C;EAA/C,mBAA+C;EAA/C,oBAA+C;EAA/C,oBAA+C;EAA/C;AAA+C;;AAI/C;EAAA;AAAqB;;AAArB;;EAAA;IAAA;EAAqB;AAAA;;AAIrB;EAAA,eAA2G;EAA3G,sBAA2G;EAA3G,+DAA2G;EAA3G,oBAA2G;EAA3G,+CAA2G;EAA3G,wBAA2G;EAA3G,wDAA2G;EAA3G;AAA2G;;AAA3G;EAAA,wBAA2G;EAA3G,oBAA2G;EAA3G;AAA2G;AAG3G;EAAA,kBAA2B;EAA3B,iBAA2B;EAA3B,oBAA2B;EAA3B;AAA2B;AAE7B,KAAK;AAEH;EAAA,YAA+B;EAA/B,WAA+B;EAA/B;AAA+B;AAA/B;;EAAA;IAAA;EAA+B;AAAA;;AAGjC,YAAY;AAEV;EAAA,iBAAyH;EAAzH,kBAAyH;EAAzH,kBAAyH;EAAzH,aAAyH;EAAzH,WAAyH;EAAzH,sBAAyH;EAAzH,mBAAyH;EAAzH,WAAyH;EAAzH,cAAyH;EAAzH,eAAyH;EAAzH,kBAAyH;EAAzH,mBAAyH;EAAzH;AAAyH;AAAzH;;EAAA;IAAA,UAAyH;IAAzH,eAAyH;IAAzH;EAAyH;AAAA;AAGzH;EAAA,gBAA4D;EAA5D,mBAA4D;EAA5D,mBAA4D;EAA5D,oBAA4D;EAA5D,gBAA4D;EAA5D,sBAA4D;EAA5D,oBAA4D;EAA5D;AAA4D;AAG5D;EAAA,mBAA+B;EAA/B,aAA+B;EAA/B,sBAA+B;EAA/B;AAA+B;AAG/B;EAAA,eAAwE;EAAxE,sBAAwE;EAAxE,kBAAwE;EAAxE,sDAAwE;EAAxE,gBAAwE;EAAxE,gKAAwE;EAAxE,wJAAwE;EAAxE,iLAAwE;EAAxE,wDAAwE;EAAxE;AAAwE;AAAxE;EAAA,iBAAwE;EAAxE,iBAAwE;EAAxE;AAAwE;AAE1E,KAAK;AACL,aAAa;AAEX;EAAA,eAAuE;EAAvE,WAAuE;EAAvE,aAAuE;EAAvE,WAAuE;EAAvE,eAAuE;EAAvE,mBAAuE;EAAvE;AAAuE;AAAvE;;EAAA;IAAA;EAAuE;AAAA;AAGvE;EAAA,wBAAsD;EAAtD,sBAAsD;EAAtD,6DAAsD;EAAtD,6BAAsD;EAAtD,+QAAsD;UAAtD;AAAsD;AAExD,KAAK;AAEH;EAAA,kBAAiD;EAAjD,iBAAiD;EAAjD,kBAAiD;EAAjD,YAAiD;EAAjD,WAAiD;EAAjD,yBAAiD;UAAjD;AAAiD;AAGjD;EAAA,eAAiL;EAAjL,SAAiL;EAAjL,UAAiL;EAAjL,WAAiL;EAAjL,aAAiL;EAAjL,mBAAiL;EAAjL,8BAAiL;EAAjL,wBAAiL;EAAjL,sBAAiL;EAAjL,+DAAiL;EAAjL,sDAAiL;EAAjL,oBAAiL;EAAjL,mBAAiL;EAAjL,sBAAiL;EAAjL,oBAAiL;EAAjL,qBAAiL;EAAjL,8BAAiL;EAAjL,+QAAiL;UAAjL;AAAiL;AAAjL;;EAAA;IAAA,kBAAiL;IAAjL;EAAiL;AAAA;AAAjL;;EAAA;IAAA,oBAAiL;IAAjL;EAAiL;AAAA;AAAjL;;EAAA;IAAA,kBAAiL;IAAjL;EAAiL;AAAA;AAGjL;EAAA;AAAqB;AAArB;;EAAA;IAAA;EAAqB;AAAA;AAGrB;EAAA,kBAAgJ;EAAhJ,aAAgJ;EAAhJ,SAAgJ;EAAhJ,WAAgJ;EAAhJ,aAAgJ;EAAhJ,YAAgJ;EAAhJ,iBAAgJ;EAAhJ,sBAAgJ;EAAhJ,mBAAgJ;EAAhJ,SAAgJ;EAAhJ,qBAAgJ;EAAhJ,kBAAgJ;EAAhJ,sDAAgJ;EAAhJ,aAAgJ;EAAhJ,6EAAgJ;EAAhJ,iGAAgJ;EAAhJ;AAAgJ;AAAhJ;;EAAA;IAAA;EAAgJ;AAAA;AAElJ;EACE,kCAAkC;AACpC;AACA;EACE;IACE,2BAA2B;IAC3B,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;AAEE;EAAA,WAAoG;EAApG,eAAoG;EAApG,sBAAoG;EAApG,kBAAoG;EAApG,wBAAoG;EAApG,wDAAoG;EAApG;AAAoG;AAApG;EAAA,oBAAoG;EAApG;AAAoG;AAApG;EAAA,iBAAoG;EAApG,iBAAoG;EAApG;AAAoG;AAGpG;EAAA,WAAkH;EAAlH,sBAAkH;EAAlH,kBAAkH;EAAlH,wDAAkH;EAAlH,eAAkH;EAAlH,gBAAkH;EAAlH,oBAAkH;EAAlH,6CAAkH;EAAlH,wBAAkH;EAAlH,wDAAkH;EAAlH;AAAkH;AAAlH;EAAA,kBAAkH;EAAlH,kBAAkH;EAAlH;AAAkH;AAAlH;EAAA,iBAAkH;EAAlH,iBAAkH;EAAlH;AAAkH;AAGlH;EAAA,kBAA6L;EAA7L,gBAA6L;EAA7L,aAA6L;EAA7L,sBAA6L;EAA7L,mBAA6L;EAA7L,WAA6L;EAA7L,yDAA6L;EAA7L,4BAA6L;EAA7L,eAA6L;EAA7L,mBAA6L;EAA7L,sBAA6L;EAA7L,kBAA6L;EAA7L,mBAA6L;EAA7L,mBAA6L;EAA7L;AAA6L;AAA7L;;EAAA;IAAA,gBAA6L;IAA7L,gBAA6L;IAA7L,mBAA6L;IAA7L,SAA6L;IAA7L;EAA6L;AAAA;AAA7L;;EAAA;IAAA;EAA6L;AAAA;AAA7L;;EAAA;IAAA;EAA6L;AAAA;AAG7L;EAAA,WAA2F;EAA3F,aAA2F;EAA3F,gBAA2F;EAA3F,sBAA2F;EAA3F,YAA2F;EAA3F,qBAA2F;EAA3F,6BAA2F;EAA3F,+QAA2F;UAA3F;AAA2F;AAA3F;;EAAA;IAAA;EAA2F;AAAA;AAA3F;;EAAA;IAAA;EAA2F;AAAA;AAG3F;EAAA,YAA2I;EAA3I,gBAA2I;EAA3I,uBAA2I;EAA3I,mBAA2I;EAA3I,mBAA2I;EAA3I,sBAA2I;EAA3I,yDAA2I;EAA3I;AAA2I;AAA3I;;EAAA;IAAA,kBAA2I;IAA3I,aAA2I;IAA3I;EAA2I;AAAA;AAG3I;EAAA,YAAmD;EAAnD,WAAmD;EAAnD;AAAmD;AAAnD;;EAAA;IAAA;EAAmD;AAAA;AAGnD;EAAA,WAA4H;EAA5H,sBAA4H;EAA5H,kBAA4H;EAA5H,wDAA4H;EAA5H,kBAA4H;EAA5H,mBAA4H;EAA5H,gBAA4H;EAA5H,oBAA4H;EAA5H,6CAA4H;EAA5H,wBAA4H;EAA5H,wDAA4H;EAA5H;AAA4H;AAA5H;EAAA,kBAA4H;EAA5H,kBAA4H;EAA5H;AAA4H;AAA5H;EAAA,iBAA4H;EAA5H,iBAA4H;EAA5H;AAA4H;AAA5H;;EAAA;IAAA;EAA4H;AAAA;AAG5H;EAAA,kBAAwF;EAAxF,UAAwF;EAAxF,WAAwF;EAAxF,aAAwF;EAAxF,YAAwF;EAAxF,WAAwF;EAAxF,qBAAwF;EAAxF,6BAAwF;EAAxF,+QAAwF;UAAxF;AAAwF;AAGxF;EAAA,sBAA4H;EAA5H,kBAA4H;EAA5H,wDAA4H;EAA5H,iBAA4H;EAA5H,oBAA4H;EAA5H,kBAA4H;EAA5H,mBAA4H;EAA5H,gBAA4H;EAA5H,oBAA4H;EAA5H,6CAA4H;EAA5H,wBAA4H;EAA5H,wDAA4H;EAA5H;AAA4H;AAA5H;EAAA,kBAA4H;EAA5H,kBAA4H;EAA5H;AAA4H;AAA5H;EAAA,iBAA4H;EAA5H,iBAA4H;EAA5H;AAA4H;AAA5H;;EAAA;IAAA;EAA4H;AAAA;;AAI5H;EAAA,kBAAuB;EAAvB;AAAuB;AAGvB;EAAA;AAAa;;AAIb;EAAA,kBAAgF;EAAhF,qBAAgF;EAAhF,aAAgF;EAAhF,sBAAgF;EAAhF,mBAAgF;EAAhF,YAAgF;EAAhF,kBAAgF;EAAhF,mBAAgF;EAAhF;AAAgF;;AAAhF;;EAAA;IAAA,gBAAgF;IAAhF,mBAAgF;IAAhF;EAAgF;AAAA;AAGhF;EAAA,iBAA0F;EAA1F,kBAA0F;EAA1F,mBAA0F;EAA1F,YAA0F;EAA1F,UAA0F;EAA1F,cAA0F;EAA1F,mBAA0F;EAA1F;AAA0F;AAA1F;;EAAA;IAAA;EAA0F;AAAA;AAG1F;EAAA,kBAAsE;EAAtE,gBAAsE;EAAtE,qBAAsE;EAAtE,gBAAsE;EAAtE,gDAAsE;EAAtE,wDAAsE;EAAtE;AAAsE;AAGtE;EAAA,aAA0E;EAA1E,sBAA0E;EAA1E,SAA0E;EAA1E,mBAA0E;EAA1E,sBAA0E;EAA1E;AAA0E;AAA1E;;EAAA;IAAA,WAA0E;IAA1E,iBAA0E;IAA1E,oBAA0E;IAA1E;EAA0E;AAAA;;AAI1E;EAAA,kBAA8G;EAA9G,qBAA8G;EAA9G,aAA8G;EAA9G,sBAA8G;EAA9G,mBAA8G;EAA9G,uBAA8G;EAA9G,SAA8G;EAA9G,sBAA8G;EAA9G,kBAA8G;EAA9G,mBAA8G;EAA9G;AAA8G;;AAA9G;;EAAA;IAAA,kBAA8G;IAA9G;EAA8G;AAAA;;AAA9G;;EAAA;IAAA,oBAA8G;IAA9G;EAA8G;AAAA;;AAA9G;;EAAA;IAAA,kBAA8G;IAA9G;EAA8G;AAAA;AAG9G;EAAA,aAA2E;EAA3E,sBAA2E;EAA3E,uBAA2E;EAA3E;AAA2E;AAA3E;;EAAA;IAAA,mBAA2E;IAA3E;EAA2E;AAAA;AAA3E;;EAAA;IAAA;EAA2E;AAAA;AAG3E;EAAA,kBAAuG;EAAvG,aAAuG;EAAvG,gBAAuG;EAAvG,sBAAuG;EAAvG,YAAuG;EAAvG,gBAAuG;EAAvG,sBAAuG;EAAvG,kBAAuG;EAAvG,sDAAuG;EAAvG;AAAuG;AAAvG;;EAAA;IAAA;EAAuG;AAAA;AAGvG;EAAA,kBAA6C;EAA7C,QAA6C;EAA7C,UAA6C;EAA7C,WAA6C;EAA7C;AAA6C;AAG7C;EAAA,WAAqE;EAArE,aAAqE;EAArE,WAAqE;EAArE,sBAAqE;EAArE,SAAqE;EAArE;AAAqE;AAArE;;EAAA;IAAA,UAAqE;IAArE,WAAqE;IAArE;EAAqE;AAAA;AAGrE;EAAA,YAA8C;EAA9C,WAA8C;EAA9C,mBAA8C;EAA9C,+LAA8C;EAA9C;AAA8C;AAG9C;EAAA,WAAsC;EAAtC;AAAsC;AAAtC;;EAAA;IAAA;EAAsC;AAAA;;AAGxC;;EAEE,WAAW;EACX,aAAa;EACb;;;;GAIC;EACD,mBAAmB;EACnB,kBAAyE;EAAzE,YAAyE;EAAzE,QAAyE;EAAzE,aAAyE;EAAzE,sBAAyE;EAAzE,+LAAyE;AAC3E;;AADE;;EAAA;;IAAA;EAAyE;AAAA;AAGzE;EAAA,kBAA8C;EAA9C,aAA8C;EAA9C,gBAA8C;EAA9C,sBAA8C;EAA9C;AAA8C;AAG9C;EAAA,kBAA0E;EAA1E,UAA0E;EAA1E,QAA0E;EAA1E,aAA0E;EAA1E,aAA0E;EAA1E,aAA0E;EAA1E;AAA0E;AAG1E;EAAA,WAAkH;EAAlH,kBAAkH;EAAlH,WAAkH;EAAlH,qBAAkH;EAAlH,kBAAkH;EAAlH,sDAAkH;EAAlH,eAAkH;EAAlH,6BAAkH;EAAlH,+QAAkH;UAAlH;AAAkH;AAAlH;;EAAA;IAAA,gBAAkH;IAAlH;EAAkH;AAAA;AAAlH;;EAAA;IAAA;EAAkH;AAAA;AAGlH;EAAA,cAAgC;EAAhC;AAAgC;AAAhC;;EAAA;IAAA,YAAgC;IAAhC;EAAgC;AAAA;AAGhC;EAAA,aAAwC;EAAxC,sBAAwC;EAAxC,SAAwC;EAAxC;AAAwC;AAAxC;;EAAA;IAAA;EAAwC;AAAA;AAE1C;EACE,0BAA0B;EAC1B,aAAwF;EAAxF,SAAwF;EAAxF,cAAwF;EAAxF,yDAAwF;EAAxF,iBAAwF;EAAxF,oBAAwF;EAAxF,kBAAwF;EAAxF,mBAAwF;AAC1F;AADE;;EAAA;IAAA,iBAAwF;IAAxF;EAAwF;AAAA;AAAxF;;EAAA;IAAA;EAAwF;AAAA;;AAIxF;EAAA,iBAAsE;EAAtE,kBAAsE;EAAtE,cAAsE;EAAtE,aAAsE;EAAtE,mBAAsE;EAAtE,kBAAsE;EAAtE,YAAsE;EAAtE,yBAAsE;EAAtE;AAAsE;AAGtE;EAAA,WAAqH;EAArH,aAAqH;EAArH,iBAAqH;EAArH,gBAAqH;EAArH,gBAAqH;EAArH,sBAAqH;EAArH,YAAqH;EAArH,qBAAqH;EAArH,kBAAqH;EAArH,sDAAqH;EAArH;AAAqH;AAArH;;EAAA;IAAA,eAAqH;IAArH,mBAAqH;IAArH;EAAqH;AAAA;;AAIrH;EAAA,aAAkE;EAAlE,mBAAkE;EAAlE,yDAAkE;EAAlE,iBAAkE;EAAlE,oBAAkE;EAAlE,qBAAkE;EAAlE;AAAkE;;AAAlE;;EAAA;IAAA,iBAAkE;IAAlE;EAAkE;AAAA;AAGlE;EAAA,aAAqE;EAArE,sBAAqE;EAArE,WAAqE;EAArE,oBAAqE;EAArE,qBAAqE;EAArE,iBAAqE;EAArE;AAAqE;AAArE;;EAAA;IAAA,SAAqE;IAArE,kBAAqE;IAArE;EAAqE;AAAA;AAArE;;EAAA;IAAA,oBAAqE;IAArE;EAAqE;AAAA;AAArE;;EAAA;IAAA,kBAAqE;IAArE;EAAqE;AAAA;AAGrE;EAAA,aAAmE;EAAnE,sBAAmE;EAAnE,mBAAmE;EAAnE,8BAAmE;EAAnE;AAAmE;AAAnE;;EAAA;IAAA;EAAmE;AAAA;AAGnE;EAAA,kBAA4C;EAA5C,qBAA4C;EAA5C,aAA4C;EAA5C,sBAA4C;EAA5C,mBAA4C;EAA5C;AAA4C;;AAI5C;EAAA,eAAyD;EAAzD,wBAAyD;EAAzD,wDAAyD;EAAzD;AAAyD;;AAAzD;EAAA,oBAAyD;EAAzD;AAAyD;AAGzD;EAAA,iBAAqE;EAArE,kBAAqE;EAArE,WAAqE;EAArE,UAAqE;EAArE,mBAAqE;EAArE,kBAAqE;EAArE,wDAAqE;EAArE;AAAqE;;AAGvE,KAAK;AAEH;EAAA,aAAsI;EAAtI,UAAsI;EAAtI,gBAAsI;EAAtI,sBAAsI;EAAtI,SAAsI;EAAtI,qBAAsI;EAAtI,kBAAsI;EAAtI,sDAAsI;EAAtI;AAAsI;AAAtI;;EAAA;IAAA;EAAsI;AAAA;AAAtI;;EAAA;IAAA,UAAsI;IAAtI,oBAAsI;IAAtI,qBAAsI;IAAtI,mBAAsI;IAAtI;EAAsI;AAAA;AAAtI;;EAAA;IAAA;EAAsI;AAAA;AAAtI;;EAAA;IAAA;EAAsI;AAAA;;AAItI;EAAA,aAA4C;EAA5C,WAA4C;EAA5C,sBAA4C;EAA5C,SAA4C;EAA5C;AAA4C;;AAA5C;;EAAA;IAAA;EAA4C;AAAA;AAG5C;EAAA,kBAA0J;EAA1J,qBAA0J;EAA1J,WAA0J;EAA1J,sBAA0J;EAA1J,iBAA0J;EAA1J,sBAA0J;EAA1J,wDAA0J;EAA1J,6BAA0J;EAA1J,eAA0J;EAA1J,gBAA0J;EAA1J,oBAA0J;EAA1J,+CAA0J;EAA1J,wBAA0J;EAA1J,wDAA0J;EAA1J;AAA0J;AAA1J;EAAA,kBAA0J;EAA1J,wDAA0J;EAA1J,oBAA0J;EAA1J;AAA0J;AAA1J;;EAAA;IAAA;EAA0J;AAAA;;AAG5J,KAAK;;AAEL,UAAU;AAER;EAAA,kBAAmB;EAAnB;AAAmB;AAGnB;EAAA,kBAAmB;EAAnB;AAAmB;;AAInB;EAAA,oBAAqB;EAArB;AAAqB;;AAIrB;EAAA,oBAAqB;EAArB;AAAqB;AAGrB;EAAA,oBAAqB;EAArB;AAAqB;AAGrB;EAAA,oBAAqB;EAArB;AAAqB;AAGrB;EAAA,sBAAuB;EAAvB;AAAuB;AAGvB;EAAA,sBAAuB;EAAvB;AAAuB;;AAGzB;;GAEG;AAED;EAAA,eAA0C;EAA1C,oBAA0C;EAA1C;AAA0C;AAA1C;;EAAA;IAAA,qBAA0C;IAA1C;EAA0C;AAAA;AAA1C;;EAAA;IAAA,kBAA0C;IAA1C;EAA0C;AAAA;;AAI1C;EAAA,aAA0B;EAA1B,sBAA0B;EAA1B;AAA0B;AAG1B;EAAA,mBAA6B;EAA7B,oBAA6B;EAA7B,oBAA6B;EAA7B;AAA6B;;AAI7B;EAAA,YAAyD;EAAzD,eAAyD;EAAzD,wBAAyD;EAAzD,wDAAyD;EAAzD;AAAyD;;AAAzD;EAAA,iBAAyD;EAAzD,iBAAyD;EAAzD;AAAyD;;AAIzD;EAAA;AAAU;;AAIV;EAAA,aAAuC;EAAvC,WAAuC;EAAvC,kBAAuC;EAAvC,mBAAuC;EAAvC,mBAAuC;EAAvC;AAAuC;;AAAvC;;EAAA;IAAA;EAAuC;AAAA;;AAGzC,KAAK;AAEH;EAAA,yBAAa;EAAb;AAAa;;AAIb;EAAA,kBAA4D;EAA5D,UAA4D;EAA5D,kBAA4D;EAA5D,mDAA4D;EAA5D,YAA4D;EAA5D,6BAA4D;EAA5D,+QAA4D;UAA5D;AAA4D;;AAvjB9D;EAAA,kBAyjBA;EAzjBA,kBAyjBA;EAzjBA;AAyjBA;;AAzjBA;;EAAA;IAAA;EAyjBA;;EAzjBA;IAAA;EAyjBA;;EAzjBA;IAAA;EAyjBA;;EAzjBA;IAAA;EAyjBA;;EAzjBA;IAAA;EAyjBA;;EAzjBA;IAAA;EAyjBA;;EAzjBA;IAAA;EAyjBA;;EAzjBA;IAAA;EAyjBA;;EAzjBA;IAAA,0BAyjBA;IAzjBA;EAyjBA;;EAzjBA;IAAA,iBAyjBA;IAzjBA;EAyjBA;;EAzjBA;IAAA,mBAyjBA;IAzjBA;EAyjBA;;EAzjBA;IAAA,kBAyjBA;IAzjBA;EAyjBA;;EAzjBA;IAAA,eAyjBA;IAzjBA;EAyjBA;AAAA;;AAzjBA;;EAAA;IAAA;EAyjBA;;EAzjBA;IAAA;EAyjBA;;EAzjBA;IAAA;EAyjBA;;EAzjBA;IAAA;EAyjBA;;EAzjBA;IAAA;EAyjBA;;EAzjBA;IAAA;EAyjBA;;EAzjBA;IAAA,eAyjBA;IAzjBA;EAyjBA;AAAA;;AAzjBA;;EAAA;IAAA;EAyjBA;;EAzjBA;IAAA;EAyjBA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\nhtml {\n  font-family: \"Open Sans\";\n  scroll-behavior: smooth;\n  /* user-select: none !important; */\n  -webkit-tap-highlight-color: rgba(\n    0,\n    0,\n    0,\n    0\n  ); /* handling-the blue effect on mobile device--  */\n}\n\n/* scroll removed from input type=number */\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n::-webkit-scrollbar {\n  width: 4px;\n  height: 4px;\n}\n::-webkit-scrollbar-track {\n  background-color: #141414;\n}\n::-webkit-scrollbar-thumb {\n  background-color: rgb(91, 99, 109);\n  border-radius: 20px;\n}\n\n.App {\n  @apply bg-[#111111] min-h-[100vh] flex text-[#FFFFFF] overflow-hidden;\n}\n/* /* dashboard */\n.dashboard-wrapper,\n.history-wrapper {\n  @apply p-4 pb-0 relative w-full min-h-full overflow-auto;\n}\n\n.chat-box {\n  @apply max-h-[calc(100vh-170px)] sm:max-h-[calc(100vh-130px)] overflow-auto md:w-[85%] w-[90%] mx-auto mb-3 leading-6 tracking-wide;\n}\n\n.chat-form {\n  @apply md:w-[82%] w-[90%] absolute left-[50%] -translate-x-[50%] bottom-0 sm:mb-6 mb-5;\n}\n.chat-input {\n  @apply w-[100%] m-auto bg-[#252527] border border-[#454545] outline-none lg:px-4 lg:pr-[3.4rem] px-2 pr-[3.4rem] py-2;\n}\n.mic {\n  @apply absolute right-9 mr-5 top-[16%];\n}\n.inp-btn,\n.loader {\n  @apply absolute right-4 top-[50%] -translate-y-[50%];\n}\n.chat {\n  @apply w-full my-4 mb-6 flex overflow-auto flex-col gap-2 whitespace-pre-wrap;\n}\n.user-chat {\n  @apply sm:p-4 p-2 flex items-start sm:gap-4 gap-1 bg-[#151517] relative;\n}\n.bot-top-chat {\n  @apply flex items-start sm:gap-4 gap-1 bg-[#151517];\n}\n\n.chat-history {\n  @apply w-full my-2 flex overflow-auto flex-col gap-2 whitespace-pre-wrap;\n}\n.bot-chathistory-wrapper {\n  @apply flex flex-col gap-6 bg-[#151517] relative mb-4 pb-2;\n}\n\n.user-history-chat,\n.bot-history-chat {\n  @apply sm:p-4 p-3 flex items-start  sm:gap-4 gap-1 bg-[#151517] relative;\n}\n.bot-history-chat {\n  @apply mb-5;\n}\n.query,\n.response {\n  @apply sm:max-w-[80%] max-w-[75%] text-[#CDCDCD] text-sm;\n}\n\n.bot-chat {\n  @apply flex flex-col gap-6 bg-[#151517] sm:p-4 p-2 relative;\n}\n.options {\n  @apply absolute sm:right-3 right-2 text-[#777777];\n}\n.lawyer-card-wrapper {\n  @apply p-1 flex gap-3 justify-center items-center flex-wrap mt-8;\n}\n.lawyer-card {\n  @apply relative bg-[#252527] flex flex-col justify-between h-[22rem] w-[15rem] rounded-lg shadow-md shadow-slate-700 overflow-hidden;\n}\n.banner {\n  @apply w-full min-h-[23%] bg-slate-700;\n}\n.lawyer-img {\n  @apply sm:h-24 sm:w-24 h-20 w-20 object-contain absolute left-[50%] -translate-x-[50%] top-8 z-10 rounded-full bg-slate-900;\n}\n.card-details {\n  @apply flex flex-col gap-3 justify-between mt-14 sm:p-2 p-1 text-xs;\n}\n.card-detail {\n  @apply flex justify-between items-start gap-1 text-right;\n}\n\n.refresh-btn {\n  @apply w-max md:px-6 px-3 py-2 flex items-center gap-1 bg-[#1A1A1A] border-[#383838] absolute bottom-14 left-[50%] -translate-x-[50%] sm:mb-6 mb-5;\n}\n/*  */\n.sidebar-wrapper {\n  @apply bg-[#1b1b1b] md:min-w-[290px] sm:min-w-[250px] sm:h-auto max-h-[100vh] overflow-auto h-0 w-0 sm:-translate-x-0 -translate-x-[500px] transition-all flex justify-between flex-col gap-4 p-1 text-[15px];\n}\n\n.sidebar-mobile-wrapper {\n  @apply w-[97%] h-[100vh] backdrop-blur-[3px] transition-all absolute z-40 transition-all  sm:-translate-x-[5000px];\n}\n.sidebar-mobile {\n  @apply w-[275px] h-full bg-[#141414] overflow-auto flex justify-between flex-col gap-4 p-1 pr-3 text-[15px] absolute;\n}\n.close-sidebar {\n  @apply absolute right-0 m-1 cursor-pointer;\n}\n.sidebar-crumbs {\n  @apply m-2;\n}\n.user-name-sidebar {\n  @apply capitalize;\n}\n\n.head-title {\n  @apply text-2xl w-full text-center font-bold tracking-wider text-[#E9FE53];\n}\n\n.logo-text {\n  font-family: \"Poltawski Nowy\";\n}\n.nav-item {\n  @apply cursor-pointer transition-all w-full flex items-center gap-3 rounded p-3 hover:bg-[#1C1D23];\n}\n.nav-text {\n  @apply font-medium tracking-wide;\n}\n.new-chat-btn,\n.view-profile-btn,\n.recommend-btn,\n.signup-btn,\n.signin-btn {\n  @apply w-full rounded p-2 my-2 bg-transparent border border-[#E9FE53] text-[#E9FE53] hover:bg-[#E9FE53] hover:text-black transition-all mx-auto font-bold;\n}\n.recommend-btn {\n  @apply mr-[30px];\n}\n\n/* .recentBox {\n  @apply max-h-[160px] md:max-h-[168px] lg:max-h-[180px] xl:max-h-[240px] 2xl:max-h-[400px] 3xl:max-h-[530px] overflow-auto;\n} */\n.recentItem {\n  @apply cursor-pointer py-2 px-1 rounded hover:bg-[#1C1D23];\n}\n/* .sidebar-lower {\n  @apply lg:absolute w-full lg:bottom-1;\n} */\n.user-card {\n  @apply flex justify-between items-center relative bg-[#1D1D1D] border border-[#454545] rounded-[5px] p-3 mb-2;\n}\n.drop {\n  @apply flex justify-center md:px-6 px-3 py-2 gap-1 cursor-pointer items-center text-sm absolute bottom-[3.8rem] bg-[#1D1D1D] right-2 z-20 border rounded border-[#454545];\n}\n.logout-btn {\n  @apply flex gap-1  rounded w-max;\n}\n\n/*  */\n\n.lawyerlist-wrapper {\n  @apply sm:p-4 p-1 max-w-full flex flex-col gap-4;\n}\n.lawyers-input-wrapper {\n  @apply sm:w-96 w-full sm:px-8 px-8 relative flex items-center;\n}\n.lawyer-search-input,\n.signup-input,\n.signin-input {\n  @apply w-full bg-transparent border-[1px] border-[#464646] pl-8 py-2 rounded-[4px];\n}\n.search-icon {\n  @apply absolute top-[50%] -translate-y-[50%] left-[2.5rem];\n}\n\n.selectLawyer-btns {\n  @apply flex gap-2 sm:p-4 p-2 mt-6;\n}\n.selectLawyer-btn {\n  @apply p-3 hover:bg-[#1C1D23] rounded text-[#D6D6D6];\n}\n.table-wrapper {\n  @apply sm:p-5 py-2 flex flex-col bg-[#141416] max-h-[calc(98vh-225px)] overflow-scroll;\n}\n.lawyer-detail {\n  @apply flex items-center gap-6 px-2 py-4 [&>*:nth-child(3)]:sm:min-w-[280px];\n}\n\n.table-col {\n  @apply flex flex-col gap-1 break-words  min-w-[170px] sm:max-w-[140px] max-w-[120px];\n}\n\n/* LawyerProfile */\n\n.lawyer-profile-wrapper,\n.appointment-wrapper {\n  @apply flex flex-col gap-4 lg:p-4 p-1 tracking-wide sm:max-h-[98vh] max-h-[85vh] overflow-auto;\n}\n.lawyer-profile-box {\n  @apply flex flex-col gap-6 bg-[#151517] py-6 lg:px-16 px-2;\n}\n\n.profile {\n  @apply flex sm:flex-row flex-col items-center gap-4 md:ml-10;\n}\n.basic-details {\n  @apply flex flex-col sm:items-start items-center sm:text-start text-center gap-1;\n}\n.other-details {\n  @apply mt-4 flex flex-col text-sm sm:text-base lg:gap-4 gap-2;\n}\n.detail {\n  @apply gap-1;\n}\n\n/* Appointment */\n.appointment-wrapper {\n  @apply relative h-full;\n}\n.head {\n  @apply p-2 px-8 sm:p-4 flex items-center justify-between;\n}\n.book-appointment-btn,\n.landing-login-btn {\n  @apply w-max rounded text-[#222222] font-semibold bg-[#E9FE53] py-2 sm:px-6 px-2 transition-all hover:scale-105 active:scale-95;\n}\n.appointment-coming-soon {\n  @apply w-full h-[100vh] z-20 absolute inset-0  backdrop-blur-[2px];\n}\n.coming-soon-wrapper {\n  @apply h-full w-[90%] mx-auto relative flex items-center justify-center;\n}\n\n.animated-text {\n  background: linear-gradient(135deg, #14ff89, #ffe600, #00ff1e);\n  letter-spacing: 1px;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  animation: animate 1s linear infinite;\n  padding: 20px;\n}\n\n@keyframes animate {\n  100% {\n    filter: hue-rotate(360deg);\n  }\n}\n\n/* Signup */\n.signup-wrapper,\n.signin-wrapper {\n  @apply sm:p-4 p-2 w-full min-h-full flex items-center justify-center;\n}\n.signup-input-wrapper,\n.signin-input-wrapper {\n  @apply relative h-full w-full;\n}\n.signup-icon,\n.signin-icon {\n  @apply absolute top-[50%] -translate-y-[50%] left-2;\n}\n.form-wrapper {\n  @apply flex sm:flex-row flex-col-reverse items-center sm:gap-6 gap-3 bg-[#1D1D1D] rounded-lg sm:p-4 p-2 max-w-3xl md:w-[80%] lg:w-[70%] xl:w-[60%] w-[90%];\n}\n.signup-form,\n.signin-form {\n  @apply flex flex-col gap-4 sm:w-[80%] w-[100%] bg-[#1D1D1D] sm:p-8 p-4 rounded-md;\n}\n\n.signup-input,\n.signin-input,\n.lawyer-search-input {\n  @apply outline-none focus:outline-[0.2px] focus:outline-[#E9FE53] focus:border-transparent;\n}\n.signin-info,\n.signup-info {\n  @apply w-full text-right text-sm text-[#E9FE53];\n}\n\n.signup-img {\n  @apply sm:flex hidden;\n}\n\n.link {\n  @apply cursor-pointer text-blue-400  transition-all hover:text-purple-300 border-b-[#E9FE53] hover:border-b;\n}\n.error-message {\n  @apply text-xs text-red-500;\n}\n/*  */\n.appointment-book-wrapper {\n  @apply w-full h-full sm:p-4 p-1;\n}\n\n/* Prompts */\n.prompts-wrapper {\n  @apply overflow-auto lg:w-[80%] lg:text-base text-sm w-full p-2 mt-6 mx-auto flex flex-col items-center text-center gap-6;\n}\n.title {\n  @apply text-3xl my-4 font-bold tracking-wider text-[#E9FE53];\n}\n.prompt-box {\n  @apply flex flex-col gap-4 mb-4;\n}\n.prompt {\n  @apply bg-[#1D1D1D] rounded p-3 cursor-pointer transition hover:scale-95;\n}\n/*  */\n/* ?toggler */\n.toggler {\n  @apply w-full sm:hidden flex items-center p-2 fixed z-50 cursor-pointer;\n}\n.header {\n  @apply backdrop-blur-[5px] border-b border-b-[#1D1D1D];\n}\n/*  */\n.landingPage-wrapper {\n  @apply w-full mx-auto h-full relative select-none;\n}\n.landing-nav {\n  @apply fixed left-0 right-0 z-50 backdrop-blur-[10px] bg-[#111111] border-b border-b-[#E9FE53] bg-opacity-40  py-2 lg:px-8 md:px-6 sm:px-4 px-2 flex items-center justify-between;\n}\n.landing-login-btn {\n  @apply sm:flex hidden;\n}\n.nav-dropdown {\n  @apply sm:hidden absolute right-2 top-16 bg-[#252527]  flex flex-col items-center gap-4 w-[150px] rounded-lg shadow-md p-4 z-50 animate-[fadeIn];\n}\n.nav-dropdown {\n  animation: fadeIn 0.4s ease-in-out;\n}\n@keyframes fadeIn {\n  from {\n    transform: translateY(20px);\n    opacity: 0.8;\n  }\n  to {\n    opacity: 1;\n  }\n}\n.lists {\n  @apply w-full text-center rounded transition-all active:scale-95 cursor-pointer hover:text-[#E9FE53];\n}\n.landing-login-btn-mobile {\n  @apply w-full rounded text-[#222222] font-semibold bg-[#E9FE53] p-2 transition-all hover:scale-105 active:scale-95;\n}\n.hero {\n  @apply py-2 lg:pl-8 md:pl-6 sm:pl-4 px-4 flex sm:flex-row flex-col  sm:gap-20 gap-6 items-center sm:mt-4 mt-20 leading-10 tracking-wide p-2 sm:min-h-[98vh] relative bg-landing-hero bg-fixed;\n}\n.hero-title {\n  @apply flex flex-col sm:gap-6 gap-3 max-w-2xl z-30 backdrop-blur-[1px] rounded-lg 2xl:ml-24;\n}\n.hero-img-wrapper {\n  @apply opacity-75 border-[2.5px] border-solid border-gray-400 rounded-md sm:absolute sm:right-[-200px] overflow-hidden sm:h-[70vh] h-[45vh];\n}\n.hero-img-wrapper img {\n  @apply h-full w-full sm:object-cover object-contain;\n}\n.tryNow-btn {\n  @apply sm:w-max w-full rounded text-[#222222] font-semibold bg-[#E9FE53] px-4 transition-all hover:scale-105 active:scale-95;\n}\n.try-connect-wrapper {\n  @apply absolute z-20 inset-0 w-full h-full backdrop-blur-[3px] grid place-content-center;\n}\n.try-connect-btn {\n  @apply sm:w-max py-4  rounded text-[#222222] font-semibold bg-[#E9FE53] px-12 transition-all hover:scale-105 active:scale-95;\n}\n\n.matrix-bg {\n  @apply absolute inset-0;\n}\n.matrix-bg-img {\n  @apply h-full;\n}\n\n.try-live-section {\n  @apply sm:my-20 my-10 px-4 flex flex-col items-center sm:gap-8 gap-5 text-center;\n}\n.try-chat-box {\n  @apply h-[75vh] overflow-auto md:w-[85%] w-[90%] mx-auto mb-[5rem] leading-6 tracking-wide;\n}\n.try-gpt-box {\n  @apply shadow-custom-shadow rounded-lg text-left min-h-[80vh] relative;\n}\n.try-gpt-title {\n  @apply flex flex-col sm:gap-6 gap-4 sm:text-start text-center sm:py-8 py-2;\n}\n\n.feature-section {\n  @apply flex flex-col justify-center items-center py-2 lg:px-8 md:px-6 px-4 sm:mt-10 my-2 pt-10 sm:gap-10 gap-4;\n}\n.feature-boxes {\n  @apply flex sm:flex-row flex-col justify-center sm:gap-4 gap-2 lg:h-[580px];\n}\n.feature-box {\n  @apply relative max-w-lg text-left flex flex-col md:gap-5 gap-3 bg-[#1D1D1D] rounded-xl overflow-hidden;\n}\n.feature-box-pattern {\n  @apply absolute top-0 right-0 h-[30%] w-[30%];\n}\n.feature-title {\n  @apply flex flex-col sm:w-[80%] w-full sm:gap-6 gap-4 sm:p-6 p-3 z-10;\n}\n.feature-box-pattern-img {\n  @apply h-full w-full object-contain rotate-180;\n}\n.feature-box-img {\n  @apply opacity-95 md:absolute bottom-0;\n}\n\n.feature-side-gradient,\n.feature-card-side-gradient {\n  width: 100%;\n  height: 150px;\n  background: linear-gradient(\n    90deg,\n    #e9fe53 -136.68%,\n    rgba(233, 254, 83, 0) 187.68%\n  );\n  filter: blur(200px);\n  @apply absolute -left-[400px] top-[50%] -translate-y-[50%] sm:flex hidden;\n}\n.feature-cards {\n  @apply flex flex-col gap-3 relative max-h-full;\n}\n.feature-card-side-gradient {\n  @apply absolute h-[200px] inset-0 top-[50%] -right-[200px] opacity-90 flex;\n}\n.feature-card {\n  @apply w-full md:max-w-[400px] 2xl:max-w-[500px] bg-[#1D1D1D] h-1/3 md:p-4 p-2 rounded-lg z-20 backdrop-blur-[5px];\n}\n.card-icons {\n  @apply lg:w-12 lg:h-12 w-10 h-10;\n}\n.perfect-for-section {\n  @apply sm:pt-12 pt-6 flex flex-col gap-4;\n}\n.perfect-for-box {\n  background-size: 100% 100%;\n  @apply flex lg:justify-center bg-perfect-for-bg  sm:py-24 py-12 px-4 gap-4 overflow-auto;\n}\n\n.perfect-for-icon-img {\n  @apply h-14 w-14  mx-auto object-contain text-center invert opacity-70;\n}\n.box-card {\n  @apply sm:p-6 sm:py-10 p-3 min-w-[350px] max-w-[360px] min-h-[270px] flex flex-col gap-3 bg-[#1D1D1D] rounded-lg z-10;\n}\n\n.try-gpt-bookDemo {\n  @apply grid place-items-center sm:py-16 py-12 px-3 bg-landing-hero;\n}\n.landing-footer {\n  @apply flex flex-col sm:gap-4 gap-2 lg:px-8 md:px-6 sm:px-4 px-2 py-4;\n}\n.footer-upper {\n  @apply flex sm:flex-row flex-col gap-2 justify-between items-center;\n}\n.footer-lower {\n  @apply flex flex-col items-center gap-2 my-2;\n}\n\n.landingPage-wrapper ul li {\n  @apply hover:text-[#E9FE53] cursor-pointer transition-all;\n}\n.separator {\n  @apply h-[2px] w-[90%] mx-auto opacity-50 bg-[#E9FE53] rounded-[100%];\n}\n\n/*  */\n.bookDemo-wrapper {\n  @apply flex sm:flex-row flex-col gap-4 bg-[#1D1D1D] rounded-lg max-w-3xl md:w-[80%] lg:w-[70%] xl:w-[60%] w-[90%] md:px-6 md:py-10 p-3;\n}\n\n.bookDemo-form {\n  @apply w-full flex flex-col gap-4 sm:p-0 p-1;\n}\n.bookDemo-btn {\n  @apply sm:w-max w-full rounded p-2 my-2 bg-transparent border border-[#E9FE53] text-[#E9FE53] hover:bg-[#E9FE53] hover:text-black transition-all font-bold;\n}\n\n/*  */\n\n/* utils */\n.bg-primary {\n  @apply bg-[#E9FE53];\n}\n.bg-secondary {\n  @apply bg-[#1C1D23];\n}\n\n.text-primary {\n  @apply text-[#E9FE53];\n}\n\n.text-secondary {\n  @apply text-[#B7B7B7];\n}\n.text-light {\n  @apply text-[#B1B1B1];\n}\n.text-footer {\n  @apply text-[#3D3D3D];\n}\n.border-light {\n  @apply border-[#363636];\n}\n.border-primary {\n  @apply border-[#E9FE53];\n}\n\n/* .blur-text {\n  @apply blur-[2px];\n} */\n.s-p {\n  @apply lg:px-4 md:px-3 py-1 cursor-pointer;\n}\n\n.flxCol {\n  @apply flex flex-col gap-2;\n}\n.text-para {\n  @apply text-sm text-[#A8A8A8];\n}\n\n.icons {\n  @apply cursor-pointer h-4 transition-all active:scale-110;\n}\n\n.sidebar-icons {\n  @apply h-6;\n}\n\n.back-btn-wrapper {\n  @apply w-full px-4 py-2  sm:flex hidden;\n}\n\n/*  */\n.filter-logo {\n  @apply invert;\n}\n\n.bg-overlay {\n  @apply absolute inset-0 backdrop-blur-sm bg-black opacity-30;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
